var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 6h-2m2 6h-5m5 6h-5m-9 2v-6.439c0-.208 0-.312-.02-.411a1 1 0 0 0-.09-.254c-.046-.09-.11-.172-.24-.334l-3.3-4.124a2 2 0 0 1-.24-.334 1 1 0 0 1-.09-.254C3 7.75 3 7.647 3 7.44V5.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C3.76 4 4.04 4 4.6 4h8.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 4.76 15 5.04 15 5.6v1.839c0 .208 0 .312-.02.411a1 1 0 0 1-.09.254c-.046.09-.11.172-.24.334l-3.3 4.124c-.13.162-.194.243-.24.334a1 1 0 0 0-.09.254c-.02.1-.02.203-.02.411V17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fa0cc2fcfdcf8c1637f48c3051e6296f.svg";
export { ForwardRef as ReactComponent };